window.theme = window.theme || {};

  (function(){
    'use strict';
  
    theme.delegate = {
      on: function(event, callback, options){
        if( !this.namespaces ) // save the namespaces on the DOM element itself
          this.namespaces = {};
    
        this.namespaces[event] = callback;
        options = options || false;
    
        this.addEventListener(event.split('.')[0], callback, options);
        return this;
      },
      off: function(event) {
        if (!this.namespaces) { return }
        this.removeEventListener(event.split('.')[0], this.namespaces[event]);
        delete this.namespaces[event];
        return this;
      }
    };

    // Extend the DOM with these above custom methods
    window.on = Element.prototype.on = theme.delegate.on;
    window.off = Element.prototype.off = theme.delegate.off;

    theme.Currency = (function() {
        var moneyFormat = '${{amount}}';
        var superScript = theme && theme.settings && theme.settings.superScriptPrice;
      
        function formatMoney(cents, format) {
          if (!format) {
            format = theme.settings.moneyFormat;
          }
      
          if (typeof cents === 'string') {
            cents = cents.replace('.', '');
          }
          var value = '';
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          var formatString = (format || moneyFormat);
      
          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = theme.utils.defaultTo(precision, 2);
            thousands = theme.utils.defaultTo(thousands, ',');
            decimal = theme.utils.defaultTo(decimal, '.');
      
            if (isNaN(number) || number == null) {
              return 0;
            }
      
            number = (number / 100.0).toFixed(precision);
      
            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      
            return dollarsAmount + centsAmount;
          }
      
          switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2);
      
              if (superScript && value && value.includes('.')) {
                value = value.replace('.', '<sup>') + '</sup>';
              }
      
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
      
              if (superScript && value && value.includes(',')) {
                value = value.replace(',', '<sup>') + '</sup>';
              }
      
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
            case 'amount_no_decimals_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ');
              break;
          }
      
          return formatString.replace(placeholderRegex, value);
        }
      
        function getBaseUnit(variant) {
          if (!variant) {
            return;
          }
      
          if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
            return;
          }
      
          return variant.unit_price_measurement.reference_value === 1
            ? variant.unit_price_measurement.reference_unit
            : variant.unit_price_measurement.reference_value +
                variant.unit_price_measurement.reference_unit;
        }
      
        return {
          formatMoney: formatMoney,
          getBaseUnit: getBaseUnit
        }
    })();

    theme.utils = {
        defaultTo: function(value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
        },
    
        wrap: function(el, wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
        },
    
        debounce: function(wait, callback, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
            timeout = null;
            if (!immediate) callback.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) callback.apply(context, args);
        }
        },
    
        throttle: function(limit, callback) {
        var waiting = false;
        return function () {
            if (!waiting) {
            callback.apply(this, arguments);
            waiting = true;
            setTimeout(function () {
                waiting = false;
            }, limit);
            }
        }
        },
    
        prepareTransition: function(el, callback) {
        el.addEventListener('transitionend', removeClass);
    
        function removeClass(evt) {
            el.classList.remove('is-transitioning');
            el.removeEventListener('transitionend', removeClass);
        }
    
        el.classList.add('is-transitioning');
        el.offsetWidth; // check offsetWidth to force the style rendering
    
        if (typeof callback === 'function') {
            callback();
        }
        },
    
        // _.compact from lodash
        // Creates an array with all falsey values removed. The values `false`, `null`,
        // `0`, `""`, `undefined`, and `NaN` are falsey.
        // _.compact([0, 1, false, 2, '', 3]);
        // => [1, 2, 3]
        compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];
    
        while (++index < length) {
            var value = array[index];
            if (value) {
            result[resIndex++] = value;
            }
        }
        return result;
        },
    
        serialize: function(form) {
        var arr = [];
        Array.prototype.slice.call(form.elements).forEach(function(field) {
            if (
            !field.name ||
            field.disabled ||
            ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
            )
            return;
            if (field.type === 'select-multiple') {
            Array.prototype.slice.call(field.options).forEach(function(option) {
                if (!option.selected) return;
                arr.push(
                encodeURIComponent(field.name) +
                    '=' +
                    encodeURIComponent(option.value)
                );
            });
            return;
            }
            if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
            return;
            arr.push(
            encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
            );
        });
        return arr.join('&');
        }
    };

    theme.a11y = {
        trapFocus: function(options) {
          var eventsName = {
            focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
            focusout: options.namespace
              ? 'focusout.' + options.namespace
              : 'focusout',
            keydown: options.namespace
              ? 'keydown.' + options.namespace
              : 'keydown.handleFocus'
          };
      
          // Get every possible visible focusable element
          var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
          var elArray = [].slice.call(focusableEls);
          var focusableElements = elArray.filter(el => el.offsetParent !== null);
      
          var firstFocusable = focusableElements[0];
          var lastFocusable = focusableElements[focusableElements.length - 1];
      
          if (!options.elementToFocus) {
            options.elementToFocus = options.container;
          }
      
          options.container.setAttribute('tabindex', '-1');
          options.elementToFocus.focus();
      
          document.documentElement.off('focusin');
          document.documentElement.on(eventsName.focusout, function() {
            document.documentElement.off(eventsName.keydown);
          });
      
          document.documentElement.on(eventsName.focusin, function(evt) {
            if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;
      
            document.documentElement.on(eventsName.keydown, function(evt) {
              _manageFocus(evt);
            });
          });
      
          function _manageFocus(evt) {
            if (evt.keyCode !== 9) return;
            /**
             * On the first focusable element and tab backward,
             * focus the last element
             */
            if (evt.target === lastFocusable && !evt.shiftKey) {
              evt.preventDefault();
              firstFocusable.focus();
            }
          }
        },
        removeTrapFocus: function(options) {
          var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';
      
          if (options.container) {
            options.container.removeAttribute('tabindex');
          }
      
          document.documentElement.off(eventName);
        },
      
        lockMobileScrolling: function(namespace, element) {
          var el = element ? element : document.documentElement;
          document.documentElement.classList.add('lock-scroll');
          el.on('touchmove' + namespace, function() {
            return true;
          });
        },
      
        unlockMobileScrolling: function(namespace, element) {
          document.documentElement.classList.remove('lock-scroll');
          var el = element ? element : document.documentElement;
          el.off('touchmove' + namespace);
        }
    };

    theme.Drawers = (function() {
        function Drawers(id, name) {
        this.config = {
            id: id,
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + name,
            openClass: 'js-drawer-open',
            closingClass: 'js-drawer-closing',
            activeDrawer: 'drawer--is-open',
            namespace: '.drawer-' + name
        };
    
        this.nodes = {
            page: document.querySelector('#MainContent')
        };
    
        this.drawer = document.querySelector('#' + id);
        this.isOpen = false;
    
        if (!this.drawer) {
            return;
        }
    
        this.init();
        }
    
        Drawers.prototype = Object.assign({}, Drawers.prototype, {
        init: function() {
            // Setup open button(s)
            document.querySelectorAll(this.config.open).forEach(openBtn => {
            openBtn.setAttribute('aria-expanded', 'false');
            openBtn.addEventListener('click', this.open.bind(this));
            });
    
            this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));
    
            // Close modal if a drawer is opened
            document.addEventListener('modalOpen', function() {
            this.close();
            }.bind(this));
        },
    
        open: function(evt, returnFocusEl) {
            if (evt) {
            evt.preventDefault();
            }
    
            if (this.isOpen) {
            return;
            }
    
            // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
            if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            evt.currentTarget.setAttribute('aria-expanded', 'true');
            this.activeSource = evt.currentTarget;
            } else if (returnFocusEl) {
            returnFocusEl.setAttribute('aria-expanded', 'true');
            this.activeSource = returnFocusEl;
            }
    
            theme.utils.prepareTransition(this.drawer, function() {
            this.drawer.classList.add(this.config.activeDrawer);
            }.bind(this));
    
            document.documentElement.classList.add(this.config.openClass);
            this.isOpen = true;
    
            theme.a11y.trapFocus({
            container: this.drawer,
            namespace: 'drawer_focus'
            });
    
            document.dispatchEvent(new CustomEvent('drawerOpen'));
            document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
    
            this.bindEvents();
        },
    
        close: function(evt) {
            if (!this.isOpen) {
            return;
            }
    
            // Do not close if click event came from inside drawer
            if (evt) {
            if (evt.target.closest('.js-drawer-close')) {
                // Do not close if using the drawer close button
            } else if (evt.target.closest('.drawer')) {
                return;
            }
            }
    
            // deselect any focused form elements
            document.activeElement.blur();
    
            theme.utils.prepareTransition(this.drawer, function() {
            this.drawer.classList.remove(this.config.activeDrawer);
            }.bind(this));
    
            document.documentElement.classList.remove(this.config.openClass);
            document.documentElement.classList.add(this.config.closingClass);
    
            window.setTimeout(function() {
            document.documentElement.classList.remove(this.config.closingClass);
            if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
                this.activeSource.setAttribute('aria-expanded', 'false');
                this.activeSource.focus();
            }
            }.bind(this), 500);
    
            this.isOpen = false;
    
            theme.a11y.removeTrapFocus({
            container: this.drawer,
            namespace: 'drawer_focus'
            });
    
            this.unbindEvents();
        },
    
        bindEvents: function() {
            // Clicking out of drawer closes it
            window.on('click' + this.config.namespace, function(evt) {
            this.close(evt)
            return;
            }.bind(this));
    
            // Pressing escape closes drawer
            window.on('keyup' + this.config.namespace, function(evt) {
            if (evt.keyCode === 27) {
                this.close();
            }
            }.bind(this));
    
            theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
        },
    
        unbindEvents: function() {
            window.off('click' + this.config.namespace);
            window.off('keyup' + this.config.namespace);
    
            theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
        }
        });
    
        return Drawers;
    })();

    theme.CartDrawer = (function() {
        var selectors = {
        drawer: '#CartDrawer',
        form: '#CartDrawerForm'
        };
    
        function CartDrawer() {
        this.form = document.querySelector(selectors.form);
        this.drawer = new theme.Drawers('CartDrawer', 'cart');
    
        this.init();
        }
    
        CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
        init: function() {
            this.cartForm = new theme.CartForm(this.form);
            this.cartForm.buildCart();
    
            document.addEventListener('ajaxProduct:added', function(evt) {
            this.cartForm.buildCart();
            this.open();
            }.bind(this));
    
            // Dev-friendly way to open cart
            document.addEventListener('cart:open', this.open.bind(this));
            document.addEventListener('cart:close', this.close.bind(this));
        },
    
         open: function() {
            this.drawer.open();
    
            theme.a11y.trapFocus({
            container: this.form,
            elementToFocus: this.form,
            namespace: 'cartdrawer_focus'
            });
         },
    
        close: function() {
            this.drawer.close();
    
            theme.a11y.removeTrapFocus({
            container: this.form,
            namespace: 'cartdrawer_focus'
            });
        }
        });
    
        return CartDrawer;
    })();

    theme.cart = {
        getCart: function() {
          var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
          return fetch(url, {
            credentials: 'same-origin',
            method: 'GET'
          }).then(response => response.json());
        },
      
        getCartProductMarkup: function() {
          var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
      
          url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
      
          return fetch(url, {
            credentials: 'same-origin',
            method: 'GET'
          })
          .then(response => response.text())
          .catch(e => console.error(e));
        },
      
        changeItem: function(key, qty) {
      
          return this._updateCart({
            url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
            data: JSON.stringify({
              id: key,
              quantity: qty
            })
          })
        },
      
        _updateCart: function(params) {
          return fetch(params.url, {
            method: 'POST',
            body: params.data,
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            }
          })
          .then(response => { return response.text() })
          .then(cart => { return cart; });
        },
      
        updateAttribute: function(key, value) {
          return this._updateCart({
            url: '/cart/update.js',
            data: JSON.stringify({
              attributes: {
                [key]: theme.cart.attributeToString(value)
              }
            })
          });
        },
      
        updateNote: function(note) {
          return this._updateCart({
            url: '/cart/update.js',
            data: JSON.stringify({
              note: theme.cart.attributeToString(note)
            })
          });
        },
      
        attributeToString: function(attribute) {
          if ((typeof attribute) !== 'string') {
            attribute += '';
            if (attribute === 'undefined') {
              attribute = '';
            }
          }
          return attribute.trim();
        }
    };

    theme.CartForm = (function() {
        var selectors = {
        products: '[data-products]',
        progressBar: '[js-progress-bar]',
        cartUpsell: '[js-cart-upsell]',
        qtySelector: '.js-qty__wrapper',
        removeSelector: '.js-cart-remove',
        purchaseSelect: '.js-purchase-select',
        upgradeBtn: '.js-upgrade-btn',
        discounts: '[data-discounts]',
        savings: '[data-savings]',
        subTotal: '[data-subtotal]',
    
        cartBubble: '.cart-link__bubble',
        checkoutBtn: '.cart__checkout'
        };
    
        var classes = {
        btnLoading: 'btn--loading'
        };
    
        var config = {
        requiresTerms: false
        };
    
        function CartForm(form) {
        if (!form) {
            return;
        }
    
        this.form = form;
        this.wrapper = form.parentNode;
        this.location = form.dataset.location;
        this.namespace = '.cart-' + this.location;
        this.products = form.querySelector(selectors.products);
        this.progressBar = form.querySelector(selectors.progressBar);
        this.cartUpsell = form.querySelector(selectors.cartUpsell);
        this.cartNonEmptyUpsell = form.querySelector(selectors.cartNonEmptyUpsell);
        this.submitBtn = form.querySelector(selectors.checkoutBtn);
    
        this.discounts = form.querySelector(selectors.discounts);
        this.savings = form.querySelector(selectors.savings);
        this.subtotal = form.querySelector(selectors.subTotal);
        this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
        this.noteInput = form.querySelector(selectors.cartNote);
    
        this.cartItemsUpdated = false;
    
        if (this.termsCheckbox) {
            config.requiresTerms = true;
        }
    
        this.init();
        }
    
        CartForm.prototype = Object.assign({}, CartForm.prototype, {
        init: function() {
            this.initQtySelectors();
            this.initRemoveSelectors();
            this.initUpdatePurchase();
            this.initPurchaseSelectors();
    
            document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

            this.form.on('submit' + this.namespace, this.onSubmit.bind(this));
    
            if (this.noteInput) {
            this.noteInput.addEventListener('change', function() {
                var newNote = this.value;
                theme.cart.updateNote(newNote);
            });
            }
    
            // Dev-friendly way to build the cart
            document.addEventListener('cart:build', function() {
            this.buildCart();
            }.bind(this));
        },
    
        reInit: function() {
            this.initQtySelectors();
            this.initRemoveSelectors();
            this.initUpdatePurchase();
            this.initPurchaseSelectors();
        },
    
        onSubmit: function(evt) {
            this.submitBtn.classList.add(classes.btnLoading);
    
            /*
            Checks for drawer or cart open class on body element
            and then stops the form from being submitted. We are also
            checking against a custom property, this.cartItemsUpdated = false.
    
            Error is handled in the quantityChanged method
    
            For Expanse/Fetch/Gem quick add, if an error is present it is alerted
            through the add to cart fetch request in quick-add.js.
    
            Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
            Expanse/Fetch/Gem when using quick add
            */
    
            if (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated ||
            document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated) {
            this.submitBtn.classList.remove(classes.btnLoading);
            evt.preventDefault();
            return false;
            }
    
            if (config.requiresTerms) {
            if (this.termsCheckbox.checked) {
                // continue to checkout
            } else {
                alert(theme.strings.cartTermsConfirmation);
                this.submitBtn.classList.remove(classes.btnLoading)
                evt.preventDefault();
                return false;
            }
            }
        },
    
        /*============================================================================
            Query cart page to get markup
        ==============================================================================*/
        _parseProductHTML: function(text) {
            const html = document.createElement('div');
            html.innerHTML = text;
    
            return {
                items: html.querySelector('.cart__items'),
                discounts: html.querySelector('.cart__discounts'),
                progressBar: html.querySelector("[js-progress-bar]"),
                cartUpsell: html.querySelector("[js-cart-upsell]")
            }
        },
    
        buildCart: function() {
            theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
        },
    
        cartMarkup: function(text) {
            var markup = this._parseProductHTML(text);
            var items = markup.items;
            var progressBar = markup.progressBar;
            var cartUpsell = markup.cartUpsell;
            var count = parseInt(items.dataset.count);
            var subtotal = items.dataset.cartSubtotal;
            var savings = items.dataset.cartSavings;
    
            this.updateCartDiscounts(markup.discounts);
            this.updateSavings(savings);
    
            if (count > 0) {
            this.wrapper.classList.remove('is-empty');
            } else {
            this.wrapper.classList.add('is-empty');
            }
    
            this.updateCount(count);

            // progressBar markup
            if(this.progressBar) {
                this.progressBar.innerHTML = progressBar.innerHTML;
            }
    
            // Append item markup
            this.products.innerHTML = '';
            this.products.append(items);

            // Build upsell markup
            if(this.cartUpsell) {
              this.cartUpsell.innerHTML = cartUpsell?.innerHTML;
            }
    
            // Update subtotal
            this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
    
            this.reInit();
            document.dispatchEvent(new CustomEvent('cart-upsell:init'));
       
    
            if (window.AOS) { AOS.refreshHard() }
    
            if (Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
            }
        },
    
        updateCartDiscounts: function(markup) {
            if (!this.discounts) {
            return;
            }
            this.discounts.innerHTML = '';
            this.discounts.append(markup);
        },
    
        /*============================================================================
            Quantity handling
        ==============================================================================*/
        initQtySelectors: function() {
            this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
            var selector = new theme.QtySelector(el, {
                namespace: this.namespace,
                isCart: true
            });
            });
        },

        /*============================================================================
            Cart remove handling
        ==============================================================================*/
        initRemoveSelectors: function() {
            this.form.querySelectorAll(selectors.removeSelector).forEach(el => {
            new theme.RemoveSelector(el);
            });
        },

        /*============================================================================
            Cart purchase handling
        ==============================================================================*/
        initUpdatePurchase: function() {
            if(this.form.querySelectorAll(selectors.upgradeBtn)) {
            this.form.querySelectorAll(selectors.upgradeBtn).forEach(el => {
                new theme.UpdatePurchase(el);
            });
            }
        },

        initPurchaseSelectors: function() {
            if(this.form.querySelectorAll(selectors.purchaseSelect)) {
            this.form.querySelectorAll(selectors.purchaseSelect).forEach(el => {
                new theme.PurchaseSelector(el);
            });
            }
        },
    
        quantityChanged: function(evt) {
            var key = evt.detail[0];
            var qty = evt.detail[1];
            var el = evt.detail[2];
    
            if (!key || !qty) {
            return;
            }
    
            // Disable qty selector so multiple clicks can't happen while loading
            if (el) {
            el.classList.add('is-loading');
            }
    
            theme.cart.changeItem(key, qty)
            .then(function(cart) {
    
                const parsedCart = JSON.parse(cart);
    
                if (parsedCart.status === 422) {
                alert(parsedCart.message);
                } else {
                const updatedItem = parsedCart.items.find(item => item.key === key);
    
                // Update cartItemsUpdated property on object so we can reference later
                if (updatedItem && (evt.type === 'cart:quantity.cart-cart-drawer' || evt.type === 'cart:quantity.cart-header')) {
                    this.cartItemsUpdated = true;
                }
    
                if ((updatedItem && evt.type === 'cart:quantity.cart-cart-drawer') || (updatedItem && evt.type === 'cart:quantity.cart-header')) {
                    if (updatedItem.quantity !== qty) {
                    }
                    // Reset property on object so that checkout button will work as usual
                    this.cartItemsUpdated = false;
                }
    
                if (parsedCart.item_count > 0) {
                    this.wrapper.classList.remove('is-empty');
                } else {
                    this.wrapper.classList.add('is-empty');
                }
                }
    
                this.buildCart();
    
                document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                    cart: parsedCart
                }
                }));
            }.bind(this))
            .catch(function(XMLHttpRequest){});
        },
    
        /*============================================================================
            Update elements of the cart
        ==============================================================================*/
        updateSubtotal: function(subtotal) {
            this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        },
    
        updateSavings: function(savings) {
            if (!this.savings) {
            return;
            }
    
            if (savings > 0) {
            var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            this.savings.classList.remove('hide');
            this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
            } else {
            this.savings.classList.add('hide');
            }
        },
    
        updateCount: function(count) {
            var countEls = document.querySelectorAll('.cart-link__bubble-num');
    
            if (countEls.length) {
            countEls.forEach(el => {
                el.innerText = count;
            });
            }
    
            // show/hide bubble(s)
            var bubbles = document.querySelectorAll(selectors.cartBubble);
            if (bubbles.length) {
            if (count > 0) {
                bubbles.forEach(b => {
                b.classList.add('cart-link__bubble--visible');
                });
            } else {
                bubbles.forEach(b => {
                b.classList.remove('cart-link__bubble--visible');
                });
            }
            }
        }
        });
    
        return CartForm;
    })();

    theme.QtySelector = (function() {
        var selectors = {
        input: '.js-qty__num',
        plus: '.js-qty__adjust--plus',
        minus: '.js-qty__adjust--minus'
        };
    
        function QtySelector(el, options) {
        this.wrapper = el;
        this.plus = el.querySelector(selectors.plus);
        this.minus = el.querySelector(selectors.minus);
        this.input = el.querySelector(selectors.input);
        this.minValue = this.input.getAttribute('min') || 1;
    
        var defaults = {
            namespace: null,
            isCart: false,
            key: this.input.dataset.id
        };
    
        this.options = Object.assign({}, defaults, options);
    
        this.init();
        }
    
        QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
        init: function() {
            this.plus.addEventListener('click', function() {
            var qty = this._getQty();
            this._change(qty + 1);
            }.bind(this));
    
            this.minus.addEventListener('click', function() {
            var qty = this._getQty();
            this._change(qty - 1);
            }.bind(this));
    
            this.input.addEventListener('change', function(evt) {
            this._change(this._getQty());
            }.bind(this));
        },
    
        _getQty: function() {
            var qty = this.input.value;
            if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
            } else {
            // Not a number. Default to 1.
            qty = 1;
            }
            return parseInt(qty);
        },
    
        _change: function(qty) {
            if (qty <= this.minValue) {
            qty = this.minValue;
            }
    
            this.input.value = qty;
    
            if (this.options.isCart) {
            document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
                detail: [this.options.key, qty, this.wrapper]
            }));
            }
        }
        });
    
        return QtySelector;
    })();

    theme.RemoveSelector = (function() {
        function cartRemoveSelector(el) {
          this.removeBtn = el;
          this.init();
        }
      
        cartRemoveSelector.prototype = Object.assign({}, cartRemoveSelector.prototype, {
          init: function() {
            this.removeBtn.addEventListener('click', function(e) {
              e.preventDefault();
    
              const url = this.removeBtn.getAttribute("href");
              this.removeBtn.classList.add("btn--loading");
    
              this._updateCart(url);
            }.bind(this));
          },
    
          _updateCart: function(url) {
            fetch(url, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => response.json)
            .then(data => {
              this.removeBtn.classList.remove("btn--loading");
              document.dispatchEvent(new CustomEvent('cart:build'));
            })
          }
        });
    
        return cartRemoveSelector;
    })();
    
      theme.UpdatePurchase = (function() {
        function cartUpdatePurchase(el) {
          this.upgradeBtn = el;
          this.init();
        }
      
        cartUpdatePurchase.prototype = Object.assign({}, cartUpdatePurchase.prototype, {
          init: function() {
            this.upgradeBtn.addEventListener('click', function(e) {
              e.preventDefault();
              this.upgradeBtn.innerText = "Upgrading...";
              this.upgradeBtn.setAttribute("disabled", "disabled");
              const sellingId = this.upgradeBtn.dataset.firstSelectedSellingPlanId;
              const lineItemIndex = this.upgradeBtn.dataset.lineItemIndex;
              const qty = parseInt(this.upgradeBtn.dataset.lineItemQuantity);
    
              this._updateCart(lineItemIndex, qty, sellingId);
            }.bind(this));
          },
    
          _updateCart: function(lineItemIndex, qty, sellingId) {
            const data = {
                line: lineItemIndex,
                quantity: qty,
                selling_plan: sellingId
              }
    
            fetch("/cart/change.js", {
              method: 'POST',
              body: JSON.stringify(data),
              dataType: 'json',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(response => response.json)
            .then(data => {
              document.dispatchEvent(new CustomEvent('cart:build'));
            })
          }
        });
    
        return cartUpdatePurchase;
    })();
    
      theme.PurchaseSelector = (function() {
        function cartPurchaseSelector(el) {
          this.purchaseSelector = el;
          this.init();
        }
      
        cartPurchaseSelector.prototype = Object.assign({}, cartPurchaseSelector.prototype, {
          init: function() {
            this.purchaseSelector.addEventListener('change', function(e) {
              e.preventDefault();
    
              const sellingId = parseInt(e.target.value);
              const lineItemIndex = this.purchaseSelector.dataset.lineItemIndex;
              const qty = parseInt(this.purchaseSelector.dataset.lineItemQuantity);
    
              this._updateCart(lineItemIndex, qty, sellingId);
            }.bind(this));
          },
    
          _updateCart: function(lineItemIndex, qty, sellingId) {
            const data = {
                line: lineItemIndex,
                quantity: qty,
                selling_plan: sellingId
              }
    
            this.purchaseSelector.setAttribute("disabled", "disabled");
            fetch("/cart/change.js", {
              method: 'POST',
              body: JSON.stringify(data),
              dataType: 'json',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(response => response.json)
            .then(data => {
              document.dispatchEvent(new CustomEvent('cart:build'));
            })
          }
        });
    
        return cartPurchaseSelector;
    })();

    if (!document.body.classList.contains('template-cart')) {
        new theme.CartDrawer();
    };

    function initUpsellSlider() {
        new Swiper("[js-upsell-slider]", {
            slidesPerView: 2,
            spaceBetween: 16,
            freeMode: true
        });
    };

    initUpsellSlider();
    initUpsellBtn();

    document.addEventListener("cart-upsell:init", function() {
      initUpsellSlider();
      initUpsellBtn();
    });

    function initUpsellBtn() {
        const upsellBtn = document.querySelectorAll("[js-upsell-btn]");

        upsellBtn.forEach( btn => {
            btn.addEventListener('click', upsellAddToCart)
        });

        function upsellAddToCart() {
            const productId = this.dataset.productId;
            this.classList.add("btn--loading");

            const data = {
                items: [
                    {
                        id: productId,
                        quantity: 1
                    }
                ]
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
            .then((response) => response.json())
            .then((data) => {
                this.classList.remove("btn--loading");
                document.dispatchEvent(new CustomEvent('cart:build'));
                document.dispatchEvent(new CustomEvent('cart:open'));
            })
        }
    }
})();
